import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import ProjetosEja from '../Components/ProjetosEja'


function Projetos(){
    return( 
        <div>
            <Header />
            <ProjetosEja/>
            <Footer />
        </div>
   
    )
   
}

export default Projetos